module.exports = __webpack_public_path__ + "static/media/love-background.bf3c1302.png";